var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResFeatures8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.24 219.15C440.24 157.09 389.82 106.67 327.76 106.67C265.7 106.67 215.27 157.09 215.27 219.15C215.27 281.21 265.7 331.64 327.76 331.64C389.82 331.64 440.24 281.21 440.24 219.15ZM425.7 220.12C425.7 274.42 382.06 318.06 327.76 318.06C273.45 318.06 229.82 274.42 229.82 220.12C229.82 165.82 273.45 122.18 327.76 122.18C382.06 122.18 425.7 165.82 425.7 220.12Z",
    id: "c44uM10Okr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.42 345.21C556.61 345.21 510.06 345.21 504.24 345.21C531.39 291.88 544.97 250.18 544.97 219.15C544.97 98.91 448 1.94 327.76 1.94C207.52 1.94 110.55 98.91 110.55 219.15C110.55 249.21 124.12 291.88 151.27 345.21C144 345.21 85.82 345.21 78.55 345.21C74.67 345.21 71.76 348.12 71.76 351.03C66.91 378.76 28.12 600.63 23.27 628.36C22.3 633.21 26.18 637.09 30.06 637.09C88.15 637.09 552.82 637.09 610.91 637.09C615.76 637.09 618.67 633.21 617.7 628.36C614.46 609.87 598.3 517.43 569.21 351.03C566.63 347.15 564.36 345.21 562.42 345.21ZM66.91 529.45C165.24 498.62 219.86 481.49 230.79 478.06C278.3 548.85 321.94 604.12 322.91 605.09C325.82 608.97 331.64 608.97 334.55 605.09C335.52 604.12 380.12 546.91 428.61 475.15C429.58 476.12 429.58 476.12 430.55 477.09C440.69 482.78 491.44 511.22 582.79 562.42L412.12 623.52L252.12 623.52L66.91 529.45ZM209.45 469.33L57.21 517.82L75.64 411.15L209.45 469.33ZM576 478.06L588.61 549.82L460.61 478.06L576 478.06ZM435.39 463.52C456.73 430.55 479.03 394.67 497.45 360.73C501.4 360.73 521.12 360.73 556.61 360.73L574.06 463.52C490.86 463.52 444.64 463.52 435.39 463.52ZM530.42 220.12C530.42 314.18 384.97 514.91 327.76 588.61C270.55 513.94 125.09 313.21 125.09 220.12C125.09 107.64 216.24 17.45 327.76 17.45C439.27 17.45 530.42 108.61 530.42 220.12ZM159.03 359.76C176.48 391.76 196.85 425.7 216.24 456.73C207 452.72 160.78 432.68 77.58 396.61L84.36 359.76C129.16 359.76 154.05 359.76 159.03 359.76ZM220.12 623.52L37.82 623.52L53.33 539.15L220.12 623.52ZM593.45 573.09L602.18 623.52L453.82 623.52L593.45 573.09Z",
    id: "a4VankS6Hb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c44uM10Okr",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c44uM10Okr",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4VankS6Hb",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4VankS6Hb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResFeatures8);
export default __webpack_public_path__ + "static/media/res-features-8.6890e5124ff1e551b3b52b02be058d99.svg";
export { ForwardRef as ReactComponent };